import { TaxRateTypeEnum } from '../../../shared/enums/tax-rate-type.enum';
import { TransformInt } from '../../../shared/decorators/transform-int.decorator';
import { AppSubjectEnum } from '../../../shared/modules/authz/enums/app-subject.enum';
import { CaslSubject } from '../../../shared/modules/authz/decorators/casl-subject.decorator';
import { BaseDto } from '../../../shared/modules/base/dtos/base.dto';
import { FileDto } from '../../../shared/modules/files/dtos/file.dto';
import { TagListDto } from '../../tags/dtos/tag-list.dto';
import { VehicleMaintenanceListDto } from '../../vehicle-maintenances/dtos/vehicle-maintenance-list.dto';
import { VehicleSearchDto } from '../../vehicles';
import { VehicleRoadWorthyCheckRecordCategoryEnum } from '../enums/vehicle-road-worthy-check-record-category.enum';
import { VehicleRoadWorthyCheckStatusEnum } from '../enums/vehicle-road-worthy-check-status.enum';

import { VehicleRoadWorthyCheckLinksDto } from './vehicle-road-worthy-check-links.dto';

/**
 * Vehicle road worthy check record DTO
 */
@CaslSubject(AppSubjectEnum.VEHICLE_ROAD_WORTHY_CHECK)
export class VehicleRoadWorthyCheckRecordDto extends BaseDto {
  code!: string;
  externalReference?: string | null;
  startsAt!: Date;
  endsAt!: Date;
  status!: VehicleRoadWorthyCheckStatusEnum;
  notes?: string | null;
  recordCategory!: VehicleRoadWorthyCheckRecordCategoryEnum;
  @TransformInt()
  vehicleId!: number;
  vehicle?: VehicleSearchDto | null;
  vehicleMaintenances?: VehicleMaintenanceListDto[] | null;
  taxRateType?: TaxRateTypeEnum | null;
  taxRate?: number | null;
  isTaxIncluded?: boolean | null;
  amount?: number | null;
  totalNet?: number | null;
  totalTax?: number | null;
  totalGross?: number | null;
  tags?: TagListDto[] | null;
  links?: VehicleRoadWorthyCheckLinksDto | null;
  files?: FileDto[] | null;
}
